<template>
  <div>
    <slot name="hero"></slot>
    <div class="main-content">
      <slot></slot>
    </div>
  </div>
</template>
<script setup lang="ts"></script>
